import { truncate as _truncate, toUpper as _toUpper } from 'lodash-es'

export const truncate = (text, length = 30, separator = '...') => {
  if (text) {
    return _truncate(text, { length, separator })
  }

  return ''
}

export const toUpperCase = (text = '') => _toUpper(text)

export default {
  truncate,
  toUpperCase,
}
